import { handleRequest } from "../utilities/requestHandler";

export const getPromotionCodes = () =>
	handleRequest("get", "/promotions");

export const createPromotionCode = (payload) =>
	handleRequest("post", "/promotions", payload);

export const updatePromotionCode = (id, payload) =>
	handleRequest("put", `/promotions/${id}`, payload);

export const deactivatePromotionCode = (id) =>
	handleRequest("delete", `/promotions/${id}`);
